import { render, staticRenderFns } from "./FAgallery.vue?vue&type=template&id=270e99f3&scoped=true&"
import script from "./FAgallery.vue?vue&type=script&lang=js&"
export * from "./FAgallery.vue?vue&type=script&lang=js&"
import style0 from "./FAgallery.vue?vue&type=style&index=0&id=270e99f3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "270e99f3",
  null
  
)

export default component.exports